import Model    from "../core/Model";

export default class Sector extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id     = options.id                || null;
        this.name   = options.name              || null;
        this.parent = options.parent && options.parent.id ? new Sector(options.parent || {}) : null ;
    }

    toJson ()
    {
        return {
            id     : this.id,
            name   : this.name,
            parent : this.parent ? this.parent.toJson() : null,
        }
    }


    isHostesses() {
        return this.id == 66;
    }

    isStands() {
        return this.id == 172;
    }
}


// WEBPACK FOOTER //
// ./resources/js/models/Sector.js